import { TextField, TextFieldProps } from '@mui/material';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

type NumberTextFieldProps = TextFieldProps &
	Pick<
		NumericFormatProps,
		'decimalScale' | 'allowNegative' | 'onValueChange' | 'fixedDecimalScale'
	>;

const NumericTextField = ({
	value,
	decimalScale = 2,
	allowNegative = false,
	onValueChange,
	fixedDecimalScale,
	...textFieldProps
}: NumberTextFieldProps) => {
	return (
		<NumericFormat
			{...textFieldProps}
			value={value}
			type='text'
			allowedDecimalSeparators={[',']}
			allowNegative={allowNegative}
			decimalScale={decimalScale}
			fixedDecimalScale={fixedDecimalScale}
			size={textFieldProps.size}
			customInput={TextField}
			disabled={textFieldProps.disabled}
			slotProps={{
				...textFieldProps.slotProps,
			}}
			onValueChange={onValueChange}
			onChange={textFieldProps.onChange}
			style={textFieldProps.sx}
		/>
	);
};

export default NumericTextField;
